import PropTypes from "prop-types";
import React, { Fragment, useEffect, useRef, useState } from "react";
import { LightgalleryProvider, LightgalleryItem } from "react-lightgallery";
import Swiper from "react-id-swiper";
import MagnifierWithFallback from "./sub-components/MagnifierWithFallback";

const ProductImageGallery = ({ product, refresh, selectedColorSize }) => {
  const [gallerySwiper, getGallerySwiper] = useState(null);
  const [thumbnailSwiper, getThumbnailSwiper] = useState(null);
  const [img, setImg] = useState("");
  const ref = useRef(null);
  const [currentPhoto, setCurrentPhoto] = useState(0);
  useEffect(() => {
    console.log("selectedColorSize changed:", selectedColorSize);
    const indexFound = ref.current.swiper.imagesToLoad
      ? Array.from(ref.current.swiper.imagesToLoad).findIndex(
          (imageElement) => {
            return imageElement.src.includes(selectedColorSize);
          }
        )
      : -1;
    if (indexFound !== -1) {
      ref.current.swiper.slideTo(indexFound);
    }
  }, [selectedColorSize]);
  // effect for swiper slider synchronize
  useEffect(() => {
    if (
      gallerySwiper !== null &&
      gallerySwiper.controller &&
      thumbnailSwiper !== null &&
      thumbnailSwiper.controller
    ) {
      gallerySwiper.controller.control = thumbnailSwiper;
      thumbnailSwiper.controller.control = gallerySwiper;
    }
  }, [gallerySwiper, thumbnailSwiper]);
  useEffect(() => {
    setImg(global.baseUrlImage + product.image[0]);
  }, [product]);
  // swiper slider settings
  const gallerySwiperParams = {
    getSwiper: getGallerySwiper,
    spaceBetween: 10,
    loopedSlides: 4,
    loop: true,
    effect: "fade",
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    renderPrevButton: () => (
      <button
        className="swiper-button-prev ht-swiper-button-nav"
        style={{
          background: "transparent",
          border: "transparent",
          fontSize: "xx-large",
        }}
      >
        <i className="pe-7s-angle-left" />
      </button>
    ),
    renderNextButton: () => (
      <button
        className="swiper-button-next ht-swiper-button-nav"
        style={{
          background: "transparent",
          border: "transparent",
          fontSize: "xx-large",
        }}
      >
        <i className="pe-7s-angle-right" />
      </button>
    ),
  };

  const thumbnailSwiperParams = {
    getSwiper: getThumbnailSwiper,
    spaceBetween: 10,
    slidesPerView: 4,
    loopedSlides: 4,
    touchRatio: 0.2,
    freeMode: true,
    loop: false,
    slideToClickedSlide: true,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    renderPrevButton: () => (
      <button className="swiper-button-prev ht-swiper-button-nav">
        <i className="pe-7s-angle-left" />
      </button>
    ),
    renderNextButton: () => (
      <button className="swiper-button-next ht-swiper-button-nav">
        <i className="pe-7s-angle-right" />
      </button>
    ),
  };
  const changePage = (index) => {
    var i = index;
    console.log(ref.current.swiper);
    if (ref.current !== null && ref.current.swiper !== null) {
      ref.current.swiper.slideTo(index);
      /*if(index > currentPhoto){
        while(index > currentPhoto) {
          ref.current.swiper.slidePrev();
          index --;
        }
      }
      else if(index < currentPhoto){
        while(index < currentPhoto) {
          ref.current.swiper.slideNext();
          index ++;
        }
    }
    else  ref.current.swiper.slideReset();
    setCurrentPhoto(i)*/
    }
  };
  return (
    <Fragment>
      <div className="product-large-image-wrapper">
        {/*product.discount || product.new ? (
          <div className="product-img-badges">
            {product.discount ? (
              <span className="pink">-{product.discount}%</span>
            ) : (
              ""
            )}
            {product.new ? <span className="purple">New</span> : ""}
          </div>
        ) : (
          ""
        )*/}

        <LightgalleryProvider key={product.sku}>
          <Swiper {...gallerySwiperParams} ref={ref}>
            {product.image &&
              product.image.map((single, key) => {
                return (
                  <div key={key}>
                    <LightgalleryItem
                      group="any"
                      key={single}
                      src={global.baseUrlImage + single}
                    >
                      <button>
                        <i className="pe-7s-expand1"></i>
                      </button>
                    </LightgalleryItem>
                    <div
                      className="single-image"
                      style={{ backgroundColor: "white", height: "100%" }}
                    >
                      {/*} <MagnifierWithFallback
                        primaryImageUrl={global.baseUrlImage + single}
                        fallbackImageUrl={global.placeholderImage}
                      />*/}
                      <div
                        style={{
                          backgroundColor: "white",
                          textAlign: "center",
                        }}
                      >
                        <img
                          id={"image-prod-" + product.id}
                          src={global.baseUrlImage + single}
                          onError={() => {
                            var elms = document.querySelectorAll(
                              "[id='" + "image-prod-" + product.id + "']"
                            );
                            for (var i = 0; i < elms.length; i++) {
                              elms[i].src = global.placeholderImage;
                              elms[i].style.objectFit = "contain";
                            }
                          }}
                          className="img-fluid"
                          style={{ objectFit: "contain" }}
                          alt=""
                        />
                      </div>
                    </div>
                  </div>
                );
              })}
          </Swiper>
          {product.image.length == 0 && (
            <div>
              <div className="single-image">
                <img
                  id={"image-prod-" + product.id}
                  src={global.placeholderImage}
                  className="img-fluid"
                  onError={() => {
                    var elms = document.querySelectorAll(
                      "[id='" + "image-prod-" + product.id + "']"
                    );
                    for (var i = 0; i < elms.length; i++) {
                      elms[i].src = global.placeholderImage;
                      elms[i].style.objectFit = "contain";
                    }
                  }}
                  alt=""
                />
              </div>
            </div>
          )}
        </LightgalleryProvider>
      </div>
      <div className="product-small-image-wrapper mt-15">
        <Swiper {...thumbnailSwiperParams} key={Math.random()}>
          {product.image &&
            product.image.map((single, key, index) => {
              return (
                <div className="single-image-thumb" key={key}>
                  <img /*onClick={() => changePage(key)}*/
                    src={global.baseUrlImage + single}
                    id={"image-prod-" + product.id}
                    onError={() => {
                      var elms = document.querySelectorAll(
                        "[id='" + "image-prod-" + product.id + "']"
                      );
                      for (var i = 0; i < elms.length; i++) {
                        elms[i].src = global.placeholderImage;
                        elms[i].style.objectFit = "contain";
                      }
                    }}
                    onClick={() => {
                      ref.current.swiper.slideTo(key);
                    }}
                    className="img-fluid image-fluid-thumb"
                    alt=""
                  />
                </div>
              );
            })}
        </Swiper>
      </div>
    </Fragment>
  );
};

ProductImageGallery.propTypes = {
  product: PropTypes.object,
};

export default ProductImageGallery;
